import React from 'react';
import { useDateHelper } from 'nekst-api';
import { InformationMessage, TextBadge } from 'features/nekst-widgets';
import { useProjectContext } from '../../view/ProjectContext';
import styles from './CurrentTransactionDetails.module.scss';

export default function CurrentTransactionDetails() {
  const projectContext = useProjectContext();
  const dateHelper = useDateHelper();

  const project = projectContext.data;
  const plan = projectContext.plan;

  if (!project) {
    return null;
  } else {
    const workflows = plan?._sourcePlans ?? [];
    const dateRange = `${dateHelper.toString(project.startDate)} - ${dateHelper.toString(project.endDate)}`;

    return (
      <InformationMessage withoutMargin>
        <div className={styles.header}>
          Current Transaction Details
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Name:</span>
          <span className={styles.value}>{project.name}</span>
        </div>
        <div className={styles.row}>
          <span className={styles.label}>Current Dates:</span>
          <span className={styles.value}>{dateRange}</span>
        </div>
        {workflows.length > 0 && (
          <div className={styles.row}>
            <span className={styles.label}>Workflows:</span>
            <span className={styles.badges}>
              {workflows.map(({ id, name }) => (
                <TextBadge key={id} text={name} isSmall />
              ))}
            </span>
          </div>
        )}
      </InformationMessage>
    );
  }
}
